import { AvatarProps, Chip } from "@mui/material";

import { ApiEnumName } from "@/common/services/enum";
import { ChatParticipantDto, ChatParticipantStatus } from "@/core/api/generated/v1";

import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";

interface Props {
  participant: Nil<ChatParticipantDto>;
  sx?: AvatarProps["sx"];
}

export function ChatParticipantStatusDisplay({ participant, sx }: Props) {
  if (!participant) {
    return null;
  }

  return (
    <Chip
      variant='filled'
      color={participant.status === ChatParticipantStatus.Active ? "success" : "error"}
      size='extraSmall'
      label={
        <InlineApiEnumValue type={ApiEnumName.ChatParticipantStatus} value={participant.status} />
      }
      sx={sx}
    />
  );
}
